const Format2 = str => Number((str?.toString()).replace(',', ''))?.toFixed(2);

export default Format2;
